import { plainCompoundVariants, plainDefaultVariants, plainDisabledVariants, plainEmphasisVariants, plainTextStyleVariants, plainTypeVariants, plainVariantSlots } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const plainAVariants = tv({
    slots: plainVariantSlots,
    variants: {
        type: plainTypeVariants,
        textStyle: plainTextStyleVariants,
        emphasis: plainEmphasisVariants,
        disabled: plainDisabledVariants,
        variant: {
            standalone: {},
            inline: {
                textSlot: 'underline'
            }
        },
        active: {
            true: {}
        }
    },
    compoundVariants: plainCompoundVariants,
    defaultVariants: {
        ...plainDefaultVariants,
        type: 'primary',
        variant: 'standalone'
    }
});
export { plainAVariants };
